import api from "./api";

export interface CustomSubscriptionRequest {
  planId: number;
  durationDays?: number;
  customEndDate?: string;
  notes?: string;
  notifyUser?: boolean;
}

export interface UserSubscriptionDetails {
  subscriptionId: number;
  userId: number;
  userName: string;
  userEmail: string;

  // Plan info
  planId: number;
  planName: string;
  planPrice: number;
  currency: string;
  billingInterval: string;

  // Subscription dates
  startDate: string;
  endDate?: string;
  nextBillingDate?: string;

  // Status
  status: string;
  autoRenew: boolean;
  isActive: boolean;

  // Custom subscription info
  isCustom: boolean;
  customNotes?: string;
  assignedByAdminName?: string;
  customAssignedAt?: string;
  daysRemaining?: number;

  // Payment info
  paymentMethod?: string;
  paymentReference?: string;
}

export const adminSubscriptionService = {
  /**
   * Obtener detalles de la suscripción de un usuario
   */
  getUserSubscription: async (userId: number): Promise<UserSubscriptionDetails> => {
    const response = await api.get<UserSubscriptionDetails>(`/api/admin/subscriptions/user/${userId}`);
    return response.data;
  },

  /**
   * Asignar suscripción custom a un usuario
   */
  assignCustomSubscription: async (
    userId: number,
    request: CustomSubscriptionRequest
  ): Promise<UserSubscriptionDetails> => {
    const response = await api.post<UserSubscriptionDetails>(
      `/api/admin/subscriptions/user/${userId}/custom`,
      request
    );
    return response.data;
  },

  /**
   * Extender suscripción custom existente
   */
  extendSubscription: async (userId: number, days: number): Promise<UserSubscriptionDetails> => {
    const response = await api.put<UserSubscriptionDetails>(
      `/api/admin/subscriptions/user/${userId}/extend?days=${days}`
    );
    return response.data;
  },

  /**
   * Cancelar suscripción custom
   */
  cancelSubscription: async (userId: number): Promise<void> => {
    await api.delete(`/api/admin/subscriptions/user/${userId}/cancel`);
  },
};

export default adminSubscriptionService;
